import React from 'react';
import { Box } from '@material-ui/core';
import moment from 'moment';
import { useSelector } from 'react-redux';

export const generatedLeadsColumn = [
  { Header: 'Lead Name', accessor: 'name' },
  {
    Header: 'Phone No.',
    accessor: 'mobile',
    Cell: (val) => {
      const lead = val.cell.row.original;
      const { moduleAccess } = useSelector(({ signInReducer }) => {
        return {
          moduleAccess: signInReducer.me
            ? signInReducer.me.data
              ? signInReducer.me.data.role
              : []
            : [],
        };
      });

      return (
        <>
          {moduleAccess.includes('bccSuperAdmin') ? (
            <Box display="flex">{lead.mobile}</Box>
          ) : null}
        </>
      );
    },
  },
  {
    Header: 'Email',
    accessor: 'email',
    Cell: (val) => {
      const lead = val.cell.row.original;
      const { moduleAccess } = useSelector(({ signInReducer }) => {
        return {
          moduleAccess: signInReducer.me
            ? signInReducer.me.data
              ? signInReducer.me.data.role
              : []
            : [],
        };
      });

      return (
        <>
          {moduleAccess.includes('bccSuperAdmin') ? (
            <Box display="flex">{lead.email}</Box>
          ) : null}
        </>
      );
    },
  },
  { Header: 'Coupon Code', accessor: 'refferCode' },
  {
    Header: 'Date',
    accessor: 'createdAt',
    Cell: (val) => {
      const lead = val.cell.row.original;
      let date = moment(lead && lead.createdAt).format('DD MMM YYYY');
      return (
        <>
          <Box display="flex">{date}</Box>
        </>
      );
    },
  },
];
